import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import {
    IMediaGalleryThumbnailItemViewProps,
    IMediaGalleryThumbnailsViewProps,
    IMediaGalleryViewProps
} from '@msdyn365-commerce-modules/media-gallery/dist/types';
import { VendorLogo } from '../utilities/vendor-logo/vendor-logo';
import { checkImage } from '../utilities/helper-functions';
// import { getPriceForSelectedVariant, PriceForSelectedVariantInput } from '@msdyn365-commerce-modules/retail-actions';
// import { reaction } from 'mobx';

let showHide = false;
const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, Thumbnails, MediaGallery, data, context } = props;
    const activeIndex = CarouselProps?.activeIndex ? CarouselProps.activeIndex : 0;
    const activeItemSrc = props.state.mediaGalleryItems?.[activeIndex]?.src ? props.state.mediaGalleryItems[activeIndex]?.src : '';

    const [isVendorLogoAvailable, setVendorLogoAvailable] = React.useState(false);
    const [vendorLogo, setVendorLogo] = React.useState('');
    // React.useEffect(() => {
    //     reaction(
    //         () => props.data.product.result,
    //         async () => {
    //             const productId = props.data.product.result!.RecordId;
    //             const priceInput = new PriceForSelectedVariantInput(
    //                 productId,
    //                 props.context.request.apiSettings.channelId,
    //                 props.data.product.result,
    //                 props.context.actionContext.requestContext.user.customerAccountNumber
    //             );
    //             await getPriceForSelectedVariant(priceInput, props.context.actionContext);
    //         }
    //     );
    // },              []);

    React.useEffect(() => {
        document.addEventListener(
            'keydown',
            event => {
                if (event.keyCode === 27) {
                    hideZoomImage();
                }
            },
            false
        );

        const itemId = data.product.result ? data.product.result.ItemId : '';
        const apiSettings = context && context.request ? context.request.apiSettings : undefined;
        const updatedItemId = itemId?.replace('/', ':');
        const vendorImageUrl =
            apiSettings && apiSettings.baseImageUrl
                ? `${apiSettings.baseImageUrl.substring(0, apiSettings.baseImageUrl.length - 1)}${updatedItemId}__logo.png`
                : '';
        setVendorLogo(vendorImageUrl);
        checkImage(vendorImageUrl)
            .then(() => setVendorLogoAvailable(true))
            .catch(() => setVendorLogoAvailable(false));

        return () => {
            document.removeEventListener('keydown', hideZoomImage, false);
        };
    }, []);

    return (
        <Module {...MediaGallery}>
            <div className='media-gallery-container' onClick={handleShowHide} role='button'>
                <div id='pdp-image-container' className='pdp-image-container' role='button'>
                    <img className='pdp-image' id='pdp-image' alt='pdp-image' src={activeItemSrc} />
                </div>

                <div className='position-relative'>
                    <Node {...CarouselProps} />
                    {isVendorLogoAvailable && vendorLogo && <VendorLogo logoUrl={vendorLogo} />}
                </div>
            </div>
            <button className='pdp-close' id='pdp-close' onClick={hideZoomImage} />
            {_renderThumbnails(Thumbnails)}
        </Module>
    );
};
const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
    const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

    return (
        <Node {...ThumbnailsContainerProps}>
            <Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
        </Node>
    );
};

const handleShowHide = () => {
    showHide = !showHide;
    if (showHide) {
        showZoomImage();
    } else {
        hideZoomImage();
    }
};
const showZoomImage = () => {
    const pdpImageContainer = document.getElementById('pdp-image-container');
    const pdpClose = document.getElementById('pdp-close');
    const bodyTag = document.getElementsByClassName('mands')[0] as HTMLElement;
    if (pdpImageContainer && pdpClose && bodyTag) {
        pdpClose.style.display = 'block';
        pdpImageContainer.style.display = 'flex';
        bodyTag.style.overflow = 'hidden';
    }
};

const hideZoomImage = () => {
    showHide = false;
    const pdpImageContainer = document.getElementById('pdp-image-container');
    const pdpClose = document.getElementById('pdp-close');
    const bodyTag = document.getElementsByClassName('mands')[0] as HTMLElement;
    if (pdpImageContainer && pdpClose && bodyTag) {
        pdpImageContainer.style.display = 'none';
        pdpClose.style.display = 'none';
        bodyTag.style.overflow = 'auto';
    }
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
    const { ThumbnailItemContainerProps, Picture } = thumbnail;

    return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
};

export default MediaGalleryView;
